import axios from 'axios'
import { workshopTypeUrl, workshopUrl, getHeader } from '@/config'

const state = {
  workshopList: [],
  workshopTypeList: []
}

const mutations = {
  SET_WORKSHOP_LIST (state, obj) {
    state.workshopList = obj
  },
  SET_STATUS_LIST (state, obj) {
    state.statusList = obj
  },
  SET_WORKSHOP_TYPE_LIST (state, obj) {
    state.workshopTypeList = obj
  }
}

const actions = {
  getWorkshopTypeList: ({ commit }) => {
    axios.get(workshopTypeUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_WORKSHOP_TYPE_LIST', response.data.data)
      })
  },
  getWorkshopList: ({ commit }, payload) => {
    console.log('getWorkshopList: ' + workshopUrl + '?begin=' + payload.begin + '&end=' + payload.end)
    axios.get(workshopUrl + '?begin=' + payload.begin + '&end=' + payload.end, { headers: getHeader() })
      .then(response => {
        console.log(response.data.data)
        commit('SET_WORKSHOP_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
